import React from 'react'
import { useSelector } from 'react-redux'
import { GDPTableContent } from './GDPTableContent'
import { selectTab } from './slice'

export const GdpTable = () => {
  const tab = useSelector(selectTab)

  return <GDPTableContent tab={tab} />
}
